module.exports = __webpack_public_path__ + "static/media/riskAge65.c061a5cf.mp3";